<template>
  <div>
    <t-tabs :items="tabNavItems" class="tw-mt-5" />
    <div class="tw-mb-2 tw-bg-white tw-p-2">
      <router-view />
    </div>
    <actions-buttons
      :message_id="messageId"
      :tier_id="selectedMsp.id"
      :tier="tierType"
      :selected="messageDetails"
    ></actions-buttons>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ActionsButtons from "@/views/Common/MessageOverview/ActionsButtons/index.vue";
import TTabs from "@/components/TTabs";
import { TIER } from "@/constants";

export default {
  name: "MessageOverviewWrap",
  components: {
    ActionsButtons,
    TTabs,
  },
  data() {
    return {
      tabNavItems: [],
      tierType: TIER.msps,
      messageId: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters("message", ["messageDetails"]),
    ...mapGetters("authentication", ["selectedMsp"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  async mounted() {
    this.setPageTitle(`Message ID: ${this.messageId}`);
    this.setPageSubtitle([]);
    this.tabNavItems = this.$secondaryNav.mspQuarantineMessageOverview(
      this.messageId
    );
  },
};
</script>
